import EnvService from '@/services/EnvService';

class LogService {
  static log(...text) {
    if (EnvService.localOrDev()) console.log(...text);
  }
  static error(text) {
    if (EnvService.localOrDev()) {
      console.error(text);
      throw new Error(text)
    } else {
      console.error('an error occurred');
      throw new Error('an error occurred');
    }
  }
}

export default LogService;
